import type { SubjectPayload } from '@Application/Subjects/Actions/subjectFetched';
import type { SubjectFieldFilter, SubjectFieldSort } from '@Application/Subjects/Queries/FetchSubjects';

export type SubjectsFetchedPayload = {
	typeId: number;
	search: string;
	page: number;
	rows: number;
	totalRecords: number;
	results: SubjectPayload[];
	fieldFilters?: SubjectFieldFilter[];
	fieldSort?: SubjectFieldSort | null;
	includeArchived?: boolean;
};

export type SubjectsFetchedAction = {
	type: 'SUBJECTS_FETCHED';
	payload: SubjectsFetchedPayload;
};

export default (payload: SubjectsFetchedPayload): SubjectsFetchedAction => ({
	type: 'SUBJECTS_FETCHED',
	payload,
});
